// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { BridgeService, BridgeServiceRequest } from '@daml.js/utility-bridge-app-v0/lib/Utility/Bridge/App/V0/Service/Bridge';

const useAcceptBridgeService: () => UseMutationResult<
  ContractId<BridgeService>,
  string,
  {
    bridgeServiceRequestCid: ContractId<BridgeServiceRequest>;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['acceptBridgeServiceRequest', ledgerApi],
    mutationFn: async ({
      bridgeServiceRequestCid,
    }) => {
      return ledgerApi.acceptBridgeServiceRequest(
        bridgeServiceRequestCid,
      );
    },
  });
};

export default useAcceptBridgeService;
